<template>
  <div style="display: flex;column-gap: 14px">
    <div class="arrow">
      <img src="@/assets/arrow_t.png" class="arrow" v-if="isTopChild" @click="handleMoveUp" />
    </div>
    <div class="arrow">
      <img src="@/assets/arrow_t.png" class="arrow arrow-rotate" v-if="isEndChild" @click="handleMoveDown" />
    </div>
  </div>
</template>

<script>
export default {
  name: "NoticeMove",
  props: {
    isFirst: {
      type: Boolean,
      default: false
    },
    row: {
      type: Object,
      default:() => {}
    },
    list: {
      type: Array,
      default:() => ([])
    }
  },
  methods: {
    handleMoveUp() {
      this.handleMove(this.list, true)
    },

    handleMoveDown() {
      this.handleMove(this.list, false);
    },

    handleMove(list, isUp) {
      try {
        let rowIndex = list.findIndex(i => i.code === this.row.code);
        let positionIndex =
            isUp === true ? rowIndex - 1 : rowIndex + 1;
        // 把当前节点移动往前/后移动一个位置
        list.splice(rowIndex, 1);
        list.splice(positionIndex, 0, this.row);
        this.$emit("change-sort", this.list);
      }catch(e) {
        console.log('e', e);
        this.$message.warning("移动失败");
      }
    }
  },
  computed:{
    isTopChild() {
      let index = -1;
      index = this.list.findIndex(i => i.code === this.row.code);
      return index > 0;
    },
    isEndChild() {
      let index = -1;
      index = this.list.findIndex(i => i.code === this.row.code);
      return index !== this.list.length - 1;
    }
  }
}
</script>

<style scoped>

.arrow {
  width: 30px;
  height: 30px;
}

.arrow-rotate {
  transform: rotate(180deg);
}

</style>
